/**
 * Initialisiert den Infinite Stream Slider
 */
export function initStreamSlider() {
    const track = document.getElementById('stream-track');
    
    if (!track) return;

    // 1. Inhalt klonen (für den Loop-Effekt)
    // Wir klonen alle Kinder und hängen sie hinten an.
    // [A][B][C] wird zu [A][B][C][A][B][C]
    const items = Array.from(track.children);
    items.forEach(item => {
        const clone = item.cloneNode(true);
        clone.classList.add('is-clone'); // Optional für Styling
        clone.setAttribute('aria-hidden', 'true'); // Screenreader sollen Klone ignorieren
        track.appendChild(clone);
    });

    // 2. Variablen für die Animation
    let xPos = 0;
    let baseSpeed = 1.0; // Basis-Geschwindigkeit (Pixel pro Frame)
    
    // Scroll Physik
    let scrollVelocity = 0;
    let lastScrollY = window.scrollY;
    let targetSpeed = baseSpeed;

    // Breite eines Sets berechnen (die Hälfte des jetzigen Tracks)
    // Wir berechnen das im Loop neu oder bei Resize, um sicher zu sein.
    let itemWidth = 0;

    function calculateWidth() {
        // Wir messen die Breite aller Original-Items inkl. Gap
        // Einfachste Methode: Gesamtbreite / 2
        itemWidth = track.scrollWidth / 2;
    }
    
    // Initial berechnen und bei Resize updaten
    calculateWidth();
    window.addEventListener('resize', calculateWidth);

    // 3. Der Animation Loop (läuft 60x pro Sekunde)
    function animate() {
        // --- Scroll Geschwindigkeit berechnen ---
        const currentScrollY = window.scrollY;
        // Differenz zum letzten Frame (Wie schnell wurde gescrollt?)
        const deltaY = currentScrollY - lastScrollY;
        
        // Wir addieren den Scroll-Speed zur Velocity
        // Faktor 0.15 bestimmt, wie stark der Slider auf Scrollen reagiert
        scrollVelocity += deltaY * 0.15; 

        // Update last scroll
        lastScrollY = currentScrollY;

        // Velocity langsam abbauen (Reibung), damit er wieder zur BaseSpeed zurückkehrt
        // Wir bewegen uns immer Richtung baseSpeed
        scrollVelocity *= 0.9; // 0.9 = Bremsfaktor (je kleiner, desto schneller bremst er)

        // Die tatsächliche Geschwindigkeit für diesen Frame
        // BaseSpeed + die durch Scrollen erzeugte Energie
        let currentSpeed = baseSpeed + scrollVelocity;

        // --- Position bewegen ---
        xPos -= currentSpeed;

        // --- Infinite Loop Logic ---
        // Wenn wir uns mehr als die Hälfte nach links bewegt haben (-itemWidth),
        // springen wir unbemerkt zurück auf 0.
        if (xPos <= -itemWidth) {
            xPos = 0;
        }
        // Falls wir durch wildes Scrollen nach oben rückwärts laufen (xPos > 0)
        else if (xPos > 0) {
            xPos = -itemWidth;
        }

        // --- CSS anwenden ---
        track.style.transform = `translate3d(${xPos}px, 0, 0)`;

        // Nächsten Frame anfordern
        requestAnimationFrame(animate);
    }

    // Animation starten
    requestAnimationFrame(animate);
}